<template>
  <div class="card" :class="{ top: top }">
    <Tag v-if="datas && datas.tags && datas.tags.length" :datas="datas.tags" />
    <van-row gutter="20">
      <van-col span="8" class="fc imgBox" align="center">
        <img class="img topImg" v-if="top" src="../../assets/images/topTyre.png" />
        <img v-else class="img" src="../../assets/images/tyre.png" />
        <div v-if="!datas.has_commodity" class="noOffered fc">
          <span>暂时无货</span>
        </div>
      </van-col>
      <!-- {{ datas.habitat }}进口+ 品牌 +原配 +规格 +载重 + 速度 +花纹 +加大载重-->
      <van-col span="15" class="right fhlud fvlr" @click="link(datas)">
        <div class="C1" :class="{ fvlr: from === 'order' }">
          <div>
            <p>{{ datas.brand.name }} {{ datas.moe ? `原配${datas.moe}` : '' }}</p>
            {{ datas.tyre_spec }}&nbsp;{{ datas.load_index }}{{ datas.speed_rating }}&nbsp;{{ datas.extra_load }}&nbsp;{{ datas.pattern }}
          </div>
          <span v-if="from === 'order'">待接单备货</span>
        </div>
        <div :class="{ fvlr: from === 'order' }">
          <span
            >厂商建议零售价*&nbsp; <span class="msrp">¥{{ Math.round(datas.msrp) }}</span>
          </span>
          <span v-if="from === 'order'">x1</span>
        </div>
        <div v-if="datas.tyrePackageLoyaltyList && datas.tyrePackageLoyaltyList.length > 0" class="fvl coupon">
          <div class="tyrePlan">
            <div v-for="(item, index) in datas.tyrePackageLoyaltyList" :key="index">已绑定{{ item.loyaltyName }}</div>
          </div>
        </div>
        <div v-if="from !== 'order'" class="fvl coupon">
          <Coupon v-if="datas.couponList && datas.couponList.length" :datas="datas.couponList" />
        </div>
      </van-col>
      <!-- <van-col v-if="from === 'order'" class="status fhlud" span="6">
        <div>待接单备货</div>
        <div>X1</div>
      </van-col> -->
    </van-row>
    <img v-if="datas.moe && datas.moe !== 'MOE-S'" @click.stop="showMo(datas.moe)" class="mo" :src="require(`../../assets/images/${datas.moe}.png`)" />
  </div>
  <van-dialog v-model:show="show" title="轮胎标识">
    <div class="fhudl">
      <div class="fvlu">
        <div class="qa fc">问</div>
        <span>{{ MOData.q }}</span>
      </div>
      <div class="fvlu">
        <div class="qa fc">答</div>
        <span>{{ MOData.a }}</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { reactive, toRefs } from 'vue'
import Tag from '@/components/tyre/Tag.vue'
import Coupon from '@/components/tyre/Coupon.vue'
export default {
  components: {
    Tag,
    Coupon
  },
  emits: ['link'],
  props: ['datas', 'top', 'from'],
  setup(props, { emit }) {
    let { datas, top, from } = toRefs(props)
    const state = reactive({
      datas,
      top,
      from,
      MOData: {},
      show: false,
      labelList: [
        { color: '#FA7268', icon: 'hot', name: '好好', id: 2 },
        { color: '#B35DB1', icon: 'diamond', name: 'FSFS', id: 4 },
        { color: '#64B41E', icon: 'timer', name: '限时促销', id: 5 }
      ]
    })
    const link = data => {
      emit('link', data)
    }
    const showMo = i => {
      i = i === 'MO-S' ? 'MOS' : i
      let qa = {
        MO: {
          q: '：什么是 MO ？',
          a: '：MO (Mercedes Original) 标识代表梅赛德斯-奔驰原厂认证轮胎'
        },
        MOE: {
          q: '：什么是 MOE ？',
          a: '：MOE (MO Extended) 标识代表梅赛德斯-奔驰原厂认证低压续航轮胎'
        },
        MO1: {
          q: '：什么是 MO1 ？',
          a: '：MO1 标识代表高性能梅赛德斯-奔驰原厂认证轮胎'
        },
        MOS: {
          q: '：什么是 MOS ？',
          a: '：MOS 标识代表静音梅赛德斯-奔驰原厂认证轮胎'
        }
      }
      state.MOData = qa[i]
      state.show = true
    }
    return {
      ...toRefs(state),
      showMo,
      link
    }
  }
}
</script>

<style lang="scss" scoped>
.tyrePlan {
  div {
    font-size: 12px;
    padding: 1px 8px;
    margin-right: 8px;
    border-radius: 18px;
    border: 1px solid #3088c5;
    color: #3088c5;
    display: inline-block;
    margin-bottom: 8px;
  }
}
.imgBox {
  position: relative;
  overflow: hidden;
  .noOffered {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(5, 5, 5, 0.3);
    color: #ffffff;
    span {
      transform: rotate(30deg);
    }
  }
}
.msrp {
  color: #3088c5;
  font-size: 16px;
  font-weight: bold;
}
.card {
  width: 100%;
  padding: 12px 20px;
  box-sizing: border-box;
  background: #ffffff;
  position: relative;
  margin-bottom: 12px;
}
.top {
  background: url('../../assets/images/topTyreBg.svg') no-repeat;
  background-size: cover;
}
.coupon {
  margin-top: 5px;
}
.img {
  width: 100%;
}
.fvlr {
  width: 100%;
}
.right {
  opacity: 0.9;
  text-align: left;
  font-size: 14px;
  color: #666666;
  div {
    margin-bottom: 4px;
  }
}

.C1 {
  width: 205px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333333;
  div {
    word-break: break-all;
  }
  p {
    font-weight: 700;
    font-size: 16px;
  }
}
.C3 {
  color: #999;
}
.mo {
  width: 49px;
  height: 49px;
  position: absolute;
  top: 0;
  right: 0;
}
.fc {
  display: flex !important;
}
.fhudl {
  padding: 10px 20px;
  font-size: 14px;
}
.fvlu {
  margin-bottom: 8px;
  span {
    text-align: left;
  }
}
.qa {
  font-size: 12px;
  background: #3088c5;
  color: #ffffff;
  padding: 1px 3px 2px;
  transform: scale(0.8);
  border-radius: 5px;
}
.fhlud {
  display: flex !important;
}
.status div {
  width: 100%;
  text-align: right;
}
</style>
